import { useContext } from 'react'

import {
  faCheck, faCog, faDownload, faXmark,
} from '@fortawesome/pro-light-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'

import { IconWithMenu, Link } from '@domain-group/suit-theme'

import handleCallbackAction from '@functions/handleCallbackAction'
import { findStatusByKey } from '@functions/status'

import usePublicationBooking from '@hooks/usePublicationBooking'
import useSelector from '@hooks/useSelector'

import PageContext from '@contexts/pageContext'

import { PublicationBookingModel } from '@models/types'

const PublicationBookingActions = (props: { publicationBooking: PublicationBookingModel}) => {
  const { publicationBooking: initPublicationBooking } = props

  const publicationBookingPayload = usePublicationBooking(initPublicationBooking)

  const {
    callbacks: {
      updatePublicationBookingPreflightStatus: updateFn,
    },
    publicationBooking,
    preflightStatus,
  } = publicationBookingPayload

  // @ts-expect-error TS2339
  const { files } = publicationBooking

  const { statuses } = useSelector(reduxState => reduxState.entities)

  const approvedStatus = findStatusByKey(statuses, 'approved')

  // @ts-expect-error TS2339
  const { key: publicationStatusKey } = preflightStatus

  const entityParams = {
    // @ts-expect-error TS2339
    preflight_status_id: approvedStatus?.id,
    publication_booking_id: publicationBooking.id,
  }

  const updatePublicationPayload = {
    callbacks: {
      action: updateFn,
    },
    entityParams,
    toastText: 'Publication Booking Updated',
  }

  const pageContext = useContext(PageContext)
  const {
    callbacks: {
      showPublicationBookingPreflightStatusModal,
    },
  } = pageContext

  return (
    <IconWithMenu
      boxProps={{ position: 'relative' }}
      icon={(
        <Link greyLink>
          <FontAwesomeIcon icon={faCog} />
        </Link>
      )}
      shouldUsePortal
    >
      {/*
       // @ts-expect-error TS2741 */}
      <IconWithMenu.Menu closeOnClick>
        {files?.layout_artwork && (
          <Link key="download" href={files?.layout_artwork} target="blank">
            <FontAwesomeIcon icon={faDownload} /> Download
          </Link>
        )}

        {publicationStatusKey !== 'approved' && (
          // @ts-expect-error TS2345
          <Link key="approved" onClick={() => handleCallbackAction(updatePublicationPayload)}>
            <FontAwesomeIcon icon={faCheck} /> Approve
          </Link>
        )}

        {publicationStatusKey !== 'rejected' && (
          <Link key="reject" onClick={() => showPublicationBookingPreflightStatusModal(updatePublicationPayload)}>
            <FontAwesomeIcon icon={faXmark} /> Reject
          </Link>
        )}
      </IconWithMenu.Menu>
    </IconWithMenu>
  )
}

export default PublicationBookingActions
